import Typist from './components/Typist';
export default Typist;
